import ArrowChevronUpDown from './ArrowChevronUpDown';

export default ArrowChevronUpDown;
